import { useState } from "react";
import Page from "./Page";
import glv from "../utils/getLocalizedValue"

function ContactForm() {
  const [newsletterEmailValid, setNewsletterEmailValid] = useState(true);
  const [contactFormErrors, setContactFormErrors] = useState({});

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    const email = e.target.elements["entry.2137927698"].value.trim();
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setNewsletterEmailValid(isValidEmail);

    if (isValidEmail) e.target.submit();
  };

  const handleContactFormSubmit = (e) => {
    e.preventDefault();
    const formElements = e.target.elements;
    const newErrors = {};

    // 빈 값 검사
    [
      "entry.1903596949",
      "entry.1536863255",
      "entry.1727895066",
      "entry.222235651",
      "entry.862553448",
    ].forEach((name) => {
      if (!formElements[name].value.trim()) {
        newErrors[name] = true;
      }
    });

    // 이메일 형식 검사
    const emailValue = formElements["entry.222235651"].value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailValue && !emailRegex.test(emailValue)) {
      newErrors["entry.222235651"] = true;
    }

    setContactFormErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      e.target.submit();
    }
  };

  return (
    <>
      <div className="flex w-full justify-center">
        <div className="flex flex-col md:flex-row items-center px-2">
          {/* Newsletter Subscribe Form */}
          <div className="flex-1 flex flex-col items-center justify-center w-full px-4 md:px-0">
            <h2 className="flex w-full text-xl font-black mb-2 text-left">
              {glv("Get updates Up-to-Date!","누구보다 빠르게 최신 소식을 접해 보세요!")}
            </h2>
            <p className="flex w-full text-sm text-left mb-4">
              {glv("Subscribe to our Newsletter for all the latest from KoolMicro.","뉴스레터를 구독하시면 KoolMicro의 최신 뉴스를 보내드립니다.")}
            </p>
            <form
              className="w-full max-w-sm grid grid-cols-1 gap-3"
              action="https://docs.google.com/forms/d/e/1FAIpQLSd5HTC0qFfTxPKsuRBiNTgrV0x9_KHYcAJdfsz8wG6YzSQGYg/formResponse"
              method="POST"
              target="_blank"
              onSubmit={handleNewsletterSubmit}
            >
              <input
                type="email"
                placeholder={glv("Email","이메일 주소")}
                name="entry.2137927698"
                className={`p-2 rounded-md border ${
                  newsletterEmailValid ? "border-gray-300" : "border-red-500"
                } text-black col-span-1 md:col-span-1`}
              />
              <div className="flex justify-center items-center text-lg mt-3">
                <button
                  type="submit"
                  className="w-[8rem] shadow-md bg-brand-electric-blue hover:bg-brand-darker-blue hover:text-white text-black font-bold p-2 rounded-md"
                >
                  {glv("Subscribe","구독하기")}
                </button>
              </div>
            </form>
          </div>

          {/* short border */}
          <div className="flex bg-black md:w-[1px] md:h-[18rem] h-[1px] w-[18rem] opacity-50 md:mx-4 lg:mx-16 md:my-0 mx-0 my-8"></div>

          {/* Right Form */}
          <div className="flex-1 flex flex-col items-center justify-center w-full px-4 md:px-0">
            <h2 className="flex w-full text-xl font-bold mb-2 text-left">
              {glv("Any Questions?","더 궁금하신 점이 있으신가요?")}
            </h2>
            <p className="flex w-full text-sm text-left mb-4">
              {glv("Fill out this form and we will be in touch shortly.","아래 양식에 적어주시면 담당자가 신속히 확인하겠습니다.")}
            </p>
            <form
              className="w-full max-w-sm grid grid-cols-1 gap-3 md:grid-cols-2 justify-center items-center"
              action="https://docs.google.com/forms/d/e/1FAIpQLSeQfaqKf7BZ712vIXys6kjaWqTeB_VYnJl00AreRWdKibjJpQ/formResponse"
              method="POST"
              target="_blank"
              onSubmit={handleContactFormSubmit}
            >
              <input
                type="text"
                placeholder={glv("Name","성명")}
                className={`p-2 rounded-md border ${
                  contactFormErrors["entry.1903596949"]
                    ? "border-red-500"
                    : "border-gray-300"
                } text-black col-span-1 md:col-span-1`}
                name="entry.1903596949"
              />
              <input
                type="text"
                placeholder={glv("Company","회사")}
                className={`p-2 rounded-md border ${
                  contactFormErrors["entry.1536863255"]
                    ? "border-red-500"
                    : "border-gray-300"
                } text-black col-span-1 md:col-span-1`}
                name="entry.1536863255"
              />
              <input
                type="text"
                placeholder={glv("Phone number","휴대전화 번호")}
                className={`p-2 rounded-md border ${
                  contactFormErrors["entry.1727895066"]
                    ? "border-red-500"
                    : "border-gray-300"
                } text-black col-span-1 md:col-span-1`}
                name="entry.1727895066"
              />
              <input
                type="email"
                placeholder={glv("Email","이메일 주소")}
                className={`p-2 rounded-md border ${
                  contactFormErrors["entry.222235651"]
                    ? "border-red-500"
                    : "border-gray-300"
                } text-black col-span-1 md:col-span-1`}
                name="entry.222235651"
              />
              <textarea
                placeholder={glv("Subject","내용")}
                className={`col-span-1 md:col-span-2 p-2 rounded-md border ${
                  contactFormErrors["entry.862553448"]
                    ? "border-red-500"
                    : "border-gray-300"
                } text-black`}
                rows="3"
                name="entry.862553448"
              ></textarea>
              <div className="col-span-1 md:col-span-2 flex justify-center items-center text-lg mt-3">
                <button
                  type="submit"
                  className="w-[8rem] shadow-md bg-brand-electric-blue hover:bg-brand-darker-blue hover:text-white text-black font-bold p-2 rounded-md"
                >
                  {glv("Submit","제출하기")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactForm;